import WidgetById from '@/app_gql/widgets/WidgetById.gql';
import { GetData } from '@/app_lib/getData';
import { WidgetResponse } from './utils';

export async function getWidgetById(id: number): Promise<WidgetResponse> {
  const data = await GetData.backend<WidgetResponse>(WidgetById, { id });
  if (!data.success) {
    throw new Error(`HTTP Error: ${data}`);
  }
  const validatedData = WidgetResponse.safeParse(data.value);
  if (!validatedData.success) {
    throw new Error(`Validation Error: ${validatedData.error}`);
  }
  return validatedData.data;
}
